import { InjectionToken } from '@angular/core';

export interface HttpOptions {
    query?: any;
    pathType?: 'relative' | 'absolute';
    responseType?: 'json' | 'blob';
    contentType?: 'json' | 'multipart/form-data';
}

export const ServiceHostToken = new InjectionToken('ServiceHost');
